import { render, staticRenderFns } from "./RecentActivity.vue?vue&type=template&id=2258a4d7&scoped=true"
import script from "./RecentActivity.vue?vue&type=script&lang=ts"
export * from "./RecentActivity.vue?vue&type=script&lang=ts"
import style0 from "./RecentActivity.vue?vue&type=style&index=0&id=2258a4d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2258a4d7",
  null
  
)

export default component.exports